import React from 'react';

/**
 * A functional component that renders a solid separator line within a row layout.
 * Typically used to visually separate sections in a page.
 *
 * @component
 * @returns {JSX.Element} A row containing a solid separator.
 */
const SectionSeparator = () => (
  <div className="row">
    <div className="separator separator-solid" />
  </div>
);

export default SectionSeparator;
